// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"v--z"};